import React from 'react'

import './message-attachment.scss'

import cn from '../../libs/class-names'

import {CommonProps, Overwrite} from '../../types'

import fileAttachmentIcon from '../../assets/icons/file-attachment.svg'

import Icon from '../icon'

type Props = Overwrite<
  CommonProps<'div'>,
  {
    headline: React.ReactNode
    button?: React.ReactNode
    icon?: React.ComponentProps<typeof Icon>['source']
  }
>

const MessageAttachment = ({className, headline, button, icon, ...props}: Props) => (
  <div {...props} className={cn('MessageAttachment', {}, className)}>
    <div className="MessageAttachment__image">
      <Icon source={icon || fileAttachmentIcon} />
    </div>
    <div className="MessageAttachment__headline">{headline}</div>
    {button && <span className="MessageAttachment__button">{button}</span>}
  </div>
)

export default MessageAttachment
